import { Fragment } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { StampCertificateVisualizeCrumbs } from 'civil-status/constants/breadcrumb';
import FormStampCertificate, {
  StampCertificateForm,
} from 'civil-status/components/stamp-certificate/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { StampCertificate } from 'shell/models/stamp-certificate';
import { transformResponseStampCertificate } from 'civil-status/utils/transformer-stamp-certificate';

const StampCertificateDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [stampCertificate] = useHttpFetch<HttpResponse<StampCertificate>, StampCertificateForm>(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseStampCertificate,
    }
  );

  const isLoading =
    stampCertificate.isLoading || stampCertificate.pristine || stampCertificate.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={StampCertificateVisualizeCrumbs} />
      {isLoading ? undefined : (
        <FormStampCertificate
          title={'Dettaglio Timbro Ceritificato'}
          onOk={noop}
          onCancel={() => {
            navigate('/stato-civile/timbri');
          }}
          disabled
          initialValues={stampCertificate.data as StampCertificateForm}
        ></FormStampCertificate>
      )}
    </Fragment>
  );
};

StampCertificateDetailPage.displayName = 'Stamp Certificate Detail page component';

export default StampCertificateDetailPage;
